<template>
    <ModalWithButton
        name="crear-direccion"
        title="Crear nueva dirección fiscal"
        button_title="Crear nueva dirección fiscal"
        :disabled="disabled"
        @cerrar="direccionFiscal = {}"
    >
        <FormDireccionFiscal
            :direccionFiscal="direccionFiscal"
            @terminado="crearDireccionFiscal()"
        />
    </ModalWithButton>
</template>

<script>
    import ModalWithButton from '../../components/ModalWithButton.vue';
    import FormDireccionFiscal from '@/components/backend/direcciones-fiscales/FormDireccionFiscal';

    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                direccionFiscal: {},
                modalName: 'add-direccion-fiscal'
            }
        },
        methods: {
            crearDireccionFiscal() {
                this.direccionFiscal.filters = {};

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.direcciones.fiscales.store'), this.direccionFiscal).then(res => {
                    this.$toast.success(res.data.message);
                    this.$modal.hide('crear-direccion');
                    this.$emit('creado');
                });
            }
        },
        components: {
            ModalWithButton, FormDireccionFiscal
        }
    }
</script>
